import { render } from "./WalletFilters.vue?vue&type=template&id=70d2c854&scoped=true"
import script from "./WalletFilters.vue?vue&type=script&lang=js"
export * from "./WalletFilters.vue?vue&type=script&lang=js"

import "./WalletFilters.vue?vue&type=style&index=0&id=70d2c854&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d2c854"]])

export default __exports__